import React from 'react';
import { Link } from 'react-router-dom';
import CalsaOT from '../../assets/png/CalsaOT.png';
import Marketaudit from '../../assets/png/Marketaudit.png';

const ProjectCard = ({ project, lang }) => {
  // Determina la imagen a mostrar según el campo `image`
  const getImageSrc = () => {
    if (project.image === 'Marketaudit') {
      return Marketaudit;
    } else if (project.image === 'CalsaOT') {
      return CalsaOT;
    }
    return ''; // Valor por defecto si no coincide
  };

  return (
    <div className="projects__row">
      <div className="projects__row-img-cont">
        <img
          src={getImageSrc()} // Llama a la función para obtener la imagen correcta
          alt={project.altText}
          className="projects__row-img"
          loading="lazy"
        />
      </div>
      <div className="projects__row-content">
        <h3 className="projects__row-content-title">{project.title}</h3>
        <p className="projects__row-content-desc">{project.description}</p>
        <Link to={project.link} className="btn btn--med btn--theme dynamicBgClr">
          {lang === 'en' ? 'View Details' : 'Ver Detalles'}
        </Link>
      </div>
    </div>
  );
};

export default ProjectCard;